export const currency = (value, currency, locale) => {
  if (typeof value !== 'number') {
    return value
  }
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency
  })
  return formatter.format(value)
}

export const getPrice = (value, discount = 0, applyDiscount = false, vat = 0, applyTax = false) => {
  let price = Number(value)
  if (applyDiscount && discount > 0) {
    const discount_amount = Number(price) / 100 * discount
    price -= discount_amount
  }
  if (applyTax && vat > 0) {
    const tax = price / 100 * vat
    price += tax
  }
  return price
}
